import { render, staticRenderFns } from "./TalksRecordForm.vue?vue&type=template&id=35ccd175"
import script from "./TalksRecordForm.vue?vue&type=script&lang=js"
export * from "./TalksRecordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports